module.exports = __webpack_public_path__ + "img/37e3aac.gif";